// extracted by mini-css-extract-plugin
module.exports = {"carouselContent":"az_azc","videoContainer":"az_bzc","carouselControl":"az_czc","videoIframe":"az_dzc"};